export const LANG_SUBJECT = "Bahasa Jepang";
export const LANG_SUBJECTS = [
  { key: "Speaking", jp: "会話", label: "Speaking (会話)" },
  { key: "Listening", jp: "聴解", label: "Listening (聴解)" },
  { key: "Writing", jp: "言葉、漢字、文法", label: "Writing (言葉、漢字、文法)" },
  { key: "Reading", jp: "読解", label: "Reading (読解)" },
];
export const LANG_ORDER = LANG_SUBJECTS.map((s) => s.key);
export const LANG_LABEL = Object.fromEntries(LANG_SUBJECTS.map((s) => [s.key, s.label]));
export const subjectLabel = (sub) => LANG_LABEL[sub] || sub;
export const shortModuleName = (name = "") => name.replace(`${LANG_SUBJECT} · `, "JP ");
